import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-probus.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "login--logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "login--delighted" }, "Delighted to see you again!", -1)
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "login--forgot" }
const _hoisted_7 = ["disabled"]

import { ref, onMounted } from 'vue'
import { LoginForm } from '@/models/login'
import { useUser } from '@/store/user'
import { toastError } from '@/store/toasts'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const form = ref(new LoginForm())
const { loginUser, error, isPending, user } = useUser()
const router = useRouter()
const route = useRoute()

toastError(error)

const redirectToBookings = () => {
  let redirectUrl = route.query.returnUrl as string
  if (redirectUrl) {
    router.push(redirectUrl)
  } else {
    router.push({ name: 'bookings' })
  }
}

const checkIfLoggedIn = () => {
  if (user.value) {
    redirectToBookings()
  }
}

const onSubmit = async () => {
  await loginUser(form.value)
  redirectToBookings()
}

onMounted(checkIfLoggedIn)

return (_ctx: any,_cache: any) => {
  const _component_FormControl = _resolveComponent("FormControl")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createVNode(_component_FormControl, {
          modelValue: form.value.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.username) = $event)),
          modelModifiers: { trim: true },
          placeholder: "Username",
          autofocus: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_FormControl, {
          type: "password",
          modelValue: form.value.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
          placeholder: "Password"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(" Forgot password? reset "),
          _createVNode(_component_router_link, { to: { name: 'forgot_password' } }, {
            default: _withCtx(() => [
              _createTextVNode("here")
            ]),
            _: 1
          }),
          _createTextVNode(" please ")
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-block",
          disabled: _unref(isPending)
        }, "Enter", 8, _hoisted_7)
      ], 40, _hoisted_5)
    ])
  ]))
}
}

})